import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  IconButton,
  InputAdornment,
  Popover,
} from '@mui/material';
import AddReactionOutlinedIcon from '@mui/icons-material/AddReactionOutlined';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { STYLE_OPTIONS } from 'src/constants';

const inputAdornmentStyle = {
  color: '#B5B5B5',
  background: 'none',
  '&:hover, &:active, & .MuiTouchRipple-root': {
    background: 'none',
  },
  '&:hover svg': STYLE_OPTIONS.SVG_COLOR_BLUE,
};

function InputEndAdornment({
  isLoading,
  isAddEmojiDisabled,
  handleAddEmoji,
  handleSetFocusField,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    // We need to focus on the input after the emoji is hidden. This ensures that focus() is triggered with an updated DOM.
    setTimeout(() => {
      handleSetFocusField();
    }, 100);
  };

  return (
    <InputAdornment
      position="end"
      sx={{
        margin: 'auto 0px 11px 8px',
      }}
    >
      <IconButton
        size="small"
        onClick={handleClick}
        disabled={isLoading || isAddEmojiDisabled}
        sx={{
          ...inputAdornmentStyle,
        }}
      >
        <AddReactionOutlinedIcon
          sx={{
            color: anchorEl ? STYLE_OPTIONS.SVG_COLOR_BLUE : '#B5B5B5',
          }}
        />
      </IconButton>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{ maxWidth: '100%', width: '316px' }}
          onMouseLeave={handleClose}
        >
          <Picker
            data={data}
            theme="light"
            perLine={8}
            onEmojiSelect={handleAddEmoji}
          />
        </Box>
      </Popover>
    </InputAdornment>
  );
}

InputEndAdornment.propTypes = {
  handleAddEmoji: PropTypes.func.isRequired,
  handleSetFocusField: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isAddEmojiDisabled: PropTypes.bool,
};

InputEndAdornment.defaultProps = {
  isLoading: false,
  isAddEmojiDisabled: false,
};

export default InputEndAdornment;
